import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M29.025 23.537a1 1 0 1 1-2 0V20.07l-2.713 1.721c-1.683 1.072-3.789 1.78-6.043 2.066-2.257.286-4.598.141-6.737-.422-2.134-.562-4.015-1.528-5.373-2.821-1.363-1.298-2.165-2.9-2.165-4.614s.802-3.316 2.165-4.614c1.358-1.293 3.239-2.258 5.373-2.82 2.139-.564 4.48-.71 6.737-.423 2.255.286 4.36.994 6.044 2.066a1 1 0 0 1-1.075 1.687c-1.393-.888-3.207-1.514-5.22-1.769s-4.094-.123-5.977.372c-1.886.497-3.442 1.326-4.503 2.336-1.055 1.004-1.544 2.11-1.544 3.165s.49 2.161 1.544 3.165c1.06 1.01 2.617 1.839 4.503 2.336 1.883.495 3.965.627 5.977.372s3.827-.882 5.22-1.769l2.47-1.567h-3.683a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6"
    />
  </svg>
);
const SvgIconOvalArrow = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconOvalArrow);
export default Memo;
